import { DataWarehouseDataService } from "../../DataService/DataWarehouseDataService";
import { CommonHelper } from "../../Helpers/CommonHelper";
import { ConfirmModal } from "../../Helpers/ConfirmModal";
import { ConstantVariables } from "../../Helpers/ConstantVariables";
import { ModalHelper } from "../../Helpers/ModalHelper";
import { PaginationManager } from "../Common/PaginationManager";
import { SearchCatalogManager } from "./ArticleMatching/SearchCatalogManager";

export class UpdateLineItemArticleCodeManager {

    constructor(private containerElement: JQuery) { }

    private clearAllMatchesButton : JQuery<HTMLElement>;

    private linesTable : JQuery<HTMLElement>;
    private linesTableBody : JQuery<HTMLElement>;

    private paginationContainer: JQuery<HTMLElement>;
    private paginationManager: PaginationManager;

    private matchedLinesProgressBar: JQuery<HTMLElement>;
    private matchedLinesProgressText: JQuery<HTMLElement>;
    private lineSuggestionsPanel: JQuery<HTMLElement>;

    private selectLastRowAfterPaging: boolean = false;

    private docHeaderId : any;
    private docRevisionId : any;
    private docDetailId : any;

    private amountOfMatchedItems : any;
    private totalNumberOfItems : any;

    private searchCatalogModalHelper : ModalHelper;  
    private searchCatalogManager : SearchCatalogManager;  

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.clearAllMatchesButton = this.containerElement.find('button[data-action="clear-lines-with-matches"]');

        self.linesTable = this.containerElement.find('#lines-table');
        self.linesTableBody = self.linesTable.find('#lines-table-body');

        self.matchedLinesProgressBar = self.containerElement.find('#matched-lines-progress-bar');
        self.matchedLinesProgressText = self.containerElement.find('#article-match-progress-text');
        self.lineSuggestionsPanel = self.containerElement.find('#article-match-side-panel');

        var firstElement = self.containerElement.children().first();
        self.docHeaderId = firstElement.data('doc-header-id');
        self.docRevisionId = firstElement.data('doc-revision-id');
        self.docDetailId = firstElement.data('doc-detail-id');

        self.paginationContainer = self.containerElement.find('.article-match-navigation');
        self.paginationManager = new PaginationManager(self.paginationContainer, 50, false)

        if(self.searchCatalogModalHelper == undefined) {
            this.searchCatalogModalHelper = new ModalHelper();
            this.searchCatalogModalHelper.createModal("search-catalog-popup", true);
        }
    }

    private loadDocDetailsWithSuggestions() {
        var self = this;

        self.lineSuggestionsPanel.html(ConstantVariables.MatchArticleSidePanelEmptyState);
        self.disposeArticleMatchPopovers();

        self.linesTableBody.load('?handler=UpdateLineItemArticleCodes',
        {
            "CurrentPage" : this.paginationManager.currentPage,
            "PageSize" : this.paginationManager.pageSize,
            "DocHeaderId": self.docHeaderId,
            "DocRevisionId": self.docRevisionId,
            "DocDetailId": self.docDetailId,

            //"__RequestVerificationToken": (window as any).getToken()
        }, () => {

            this.updatePagination();
            self.bindTableRowEvents();

            if (self.selectLastRowAfterPaging) {
                self.selectLastTableRow();
            }
            else {
                self.selectFirstTableRow();
            }

            self.selectLastRowAfterPaging = false;
        });
    }

    private bindEvents() {
        var self = this;

        CommonHelper.bindDisablingSaveButton();

        self.updatePagination();

        self.lineSuggestionsPanel.html(ConstantVariables.MatchArticleSidePanelEmptyState);

        self.paginationManager.pageChanged.subscribe(() => {
            self.loadDocDetailsWithSuggestions();
        });

        self.bindTableRowEvents();
        self.bindKeyboardNavigation();
        self.selectFirstTableRow();

        self.clearAllMatchesButton.off('click').on('click', () => {
            new ConfirmModal().initialize('Clear matches', 'Are you sure you want to clear the matches? This will clear the selected match from every line.</br></br>This action cannot be reverted.', () => {
                self.clearAllMatchesButton.prop('disabled', true);

                DataWarehouseDataService.clearAllSelectedArticleMatchesForLines(self.docHeaderId, self.docRevisionId, () => {
                    self.amountOfMatchedItems = 0;
                    self.paginationManager.currentPage = 1;
                    self.loadDocDetailsWithSuggestions();
                    self.clearAllMatchesButton.prop('disabled', false);
                })
                
            }, () => {
            }, 'Confirm', 'Cancel')
        });
    }

    private bindTableRowEvents() {
        var self = this;
        const $tbl = self.linesTableBody;

        $tbl.off('click').on('click', 'tr', function () {
            $('table tbody tr.is-active').removeClass('is-active');
            $(this).addClass('is-active');

            var docDetailId = $(this).data('doc-detail-id');

            self.disposeArticleMatchPopovers();

            self.lineSuggestionsPanel.load(`?docDetailId=${docDetailId}&handler=LineItemArticleSuggestions`, () => {
                self.bindArticleSuggestionsContainer();
            })
        });
    }

    private updatePagination()
    {
        var self = this;

        var firstLine = self.linesTableBody.children().first();

        var totalNumberOfItems = firstLine.data('total-number-of-items');

        var currentPage = firstLine.data('current-page');

        var amountOfPages = Math.ceil(Number(totalNumberOfItems / self.paginationManager.pageSize));

        self.paginationManager.setPagination(currentPage, self.paginationManager.pageSize, amountOfPages, totalNumberOfItems);
        
        self.amountOfMatchedItems = firstLine.data('amount-of-matched-items');
        self.totalNumberOfItems = totalNumberOfItems;

        self.updateAmountOfMatches();

    }

    private updateAmountOfMatches() {
        var self = this;

        self.matchedLinesProgressText.text(`${self.amountOfMatchedItems} of ${self.totalNumberOfItems} items matched`)

        var percentage = 0;

        if (self.totalNumberOfItems > 0) {
            percentage = Math.round((self.amountOfMatchedItems / self.totalNumberOfItems) * 100);

            if (self.amountOfMatchedItems < self.totalNumberOfItems) {
                percentage = Math.min(percentage, 99);
            } else {
                percentage = 100;
            }
        }

        self.matchedLinesProgressBar.css('width', `${percentage}%`)
    }

    private bindArticleSuggestionsContainer() {
        var self = this;

        var docDetailId = self.lineSuggestionsPanel.children().first().data('doc-detail-id');
        var tableRow = self.linesTableBody.find(`tr[data-doc-detail-id="${docDetailId}"]`);
        var articleMatchStatusCell = tableRow.find('.article-match-status-cell');
        var statusIconSpan = articleMatchStatusCell.find('span');
        var statusIcon = articleMatchStatusCell.find('i');
        var searchCatalogButton = self.lineSuggestionsPanel.find('button[data-action="search-catalog"]');

        var hasSelection = self.lineSuggestionsPanel.find('.is-selected').length > 0;

        var matchedArticleCell = tableRow.find('.matched-article-cell');
        //suggestion-id

        self.lineSuggestionsPanel.find('button[data-suggestion-id]').each((index, element) => {
            var suggestionButton = $(element);
            var articleSuggestionId = suggestionButton.data('suggestion-id');

            suggestionButton.off('click').on('click', () => {
                var isCurrentlySelected = suggestionButton.hasClass('is-selected');

                self.lineSuggestionsPanel
                    .find('button.is-selected')
                    .not(suggestionButton)
                    .removeClass('is-selected');

                if(isCurrentlySelected) {
                    //Remove selected suggestion
                    suggestionButton.removeClass('is-selected');

                    statusIconSpan.removeClass('line-success-icon');
                    statusIcon.removeClass('fa-circle-check');
                    
                    statusIconSpan.addClass('line-warning-icon');
                    statusIcon.addClass('fa-circle-exclamation');

                    self.setUnmatchedArticleCell( matchedArticleCell );

                    DataWarehouseDataService.deleteDocDetailSelectedArticleCode(docDetailId, (result) => {
                        self.amountOfMatchedItems -= 1;
                        self.updateAmountOfMatches();

                        hasSelection = false;
                    })

                }
                else {
                    //Select item
                    suggestionButton.addClass('is-selected');
                    
                    statusIconSpan.removeClass('line-warning-icon');
                    statusIcon.removeClass('fa-circle-exclamation');

                    statusIconSpan.addClass('line-success-icon');
                    statusIcon.addClass('fa-circle-check');

                    var articleCode = suggestionButton.data('article-code') ?? '';
                    var articleDescription = suggestionButton.data('article-description') ?? '';
                    var catalog = suggestionButton.data('catalog') ?? '';

                    self.setMatchedArticleCell( matchedArticleCell, articleCode, articleDescription, catalog );
                    //Set match

                    DataWarehouseDataService.setDocDetailSelectedArticle(docDetailId, articleSuggestionId, (result) => {
                        if(hasSelection == false) {
                            self.amountOfMatchedItems += 1;
                            self.updateAmountOfMatches();
                        }

                        hasSelection = true;
                    })
                }

            })

            var scoreExplanationIcon = suggestionButton.find('.article-match-score-explanation-info');
            if(scoreExplanationIcon != undefined && scoreExplanationIcon.length > 0) {
                const explanation = scoreExplanationIcon.children().first().text();

                if (explanation != undefined && explanation.length > 0) {
                    const parsedExplanation =
                        typeof explanation === 'string'
                            ? JSON.parse(explanation)
                            : explanation;


                    const details = parsedExplanation.Details
                        .map(detail => `<li>${self.escapeHtml(detail)}</li>`)
                        .join('');

                    scoreExplanationIcon.popover({
                        html: true,
                        trigger: 'hover focus',
                        placement: 'left',
                        container: '#update-article-number-modal',
                        customClass: 'article-match-explanation-popover',
                        title: self.escapeHtml(parsedExplanation.Title),
                        sanitize: false,
                        content: `
                            <div class="article-match-explanation">
                                <p class="mb-2">
                                    ${self.escapeHtml(parsedExplanation.Summary)}
                                </p>

                                ${details.length > 0
                                    ? `
                                        <ul class="mb-0 ps-3">
                                            ${details}
                                        </ul>
                                    `
                                    : ''}
                            </div>
                        `,
                        delay: {
                            show: 150,
                            hide: 200
                        }
                    });

                }
            }
        });

        searchCatalogButton.off('click').on('click', () => {
            searchCatalogButton.prop('disabled', true);

            self.searchCatalogModalHelper.load(`?docDetailId=${docDetailId}&handler=SearchSuggestionInCatalog`, undefined, () => {
                if(self.searchCatalogManager == undefined) {
                    self.searchCatalogManager = new SearchCatalogManager(self.searchCatalogModalHelper.getModalContainer());

                    self.searchCatalogManager.articleSelectedEvent.subscribe((manager, selectedArticle) => {
                        self.setMatchedArticleCell(matchedArticleCell, selectedArticle.articleCode, selectedArticle.articleDescription, selectedArticle.catalog);
                        self.searchCatalogModalHelper.hideModal();

                        self.lineSuggestionsPanel.load(`?docDetailId=${docDetailId}&handler=LineItemArticleSuggestions`, () => {
                            self.bindArticleSuggestionsContainer();
                        })
                    });
                }

                self.searchCatalogManager.initialize(docDetailId);
                searchCatalogButton.prop('disabled', false);
            })
        })
    }

    private setMatchedArticleCell(
        matchedArticleCell: JQuery<HTMLElement>,
        articleCode: string,
        articleDescription: string,
        catalog: string
    ) {
        matchedArticleCell.html(`
            <div class="matched-article-card">
                <div class="matched-article-code">
                    ${this.escapeHtml(articleCode)}
                </div>

                <div class="matched-article-description">
                    ${this.escapeHtml(articleDescription)}
                </div>

                <span class="matched-article-source">
                    ${this.escapeHtml(catalog)}
                </span>
            </div>
        `);
    }

    private setUnmatchedArticleCell(
        matchedArticleCell: JQuery<HTMLElement>
    ) {
        matchedArticleCell.html(`
            <span class="matched-article-empty">
                Unmatched
            </span>
        `);
    }

    private escapeHtml(value: string): string {
        return $('<div>')
            .text(value ?? '')
            .html();
    }

    //#region Arrow navigation
    private bindKeyboardNavigation() {
        var self = this;

        $(document)
        .off('keydown.articleMatching')
        .on('keydown.articleMatching', (event) => {

            /*
            * Geen shortcuts uitvoeren als de gebruiker
            * in een input/select/textarea bezig is.
            */
            var target = $(event.target);

            if (
                target.is('input') ||
                target.is('textarea') ||
                target.is('select')
            ) {
                return;
            }

            switch (event.key) {

                case 'ArrowUp':
                    event.preventDefault();

                    self.moveSelectedTableRow(-1);
                    break;

                case 'ArrowDown':
                    event.preventDefault();

                    self.moveSelectedTableRow(1);
                    break;

                case 'ArrowLeft':
                    event.preventDefault();

                    self.goToPreviousPage();
                    break;

                case 'ArrowRight':
                    event.preventDefault();

                    self.goToNextPage();
                    break;
            }
        });
    }


    private moveSelectedTableRow(direction: number) {
        var self = this;

        var rows = self.linesTableBody.find('tr.article-match-line:visible');

        if (rows.length === 0) {
            return;
        }

        var selectedRow = rows.filter('.is-active');

        /*
        * Nog geen regel geselecteerd:
        * pak de eerste regel.
        */
        if (selectedRow.length === 0) {
            $(rows[0]).trigger('click');
            return;
        }

        var currentIndex = rows.index(selectedRow);

        var newIndex = currentIndex + direction;

        /*
        * Niet buiten de huidige pagina navigeren.
        */
        if (newIndex < 0 || newIndex >= rows.length) {
            return;
        }

        var newRow = $(rows[newIndex]);

        /*
        * Gebruik dezelfde click-logica als wanneer
        * de gebruiker met de muis klikt.
        */
        newRow.trigger('click');

        /*
        * Zorg dat de regel zichtbaar blijft.
        */
        newRow[0]?.scrollIntoView({
            block: 'nearest'
        });
    }


    private goToPreviousPage() {
        var self = this;
        var previousButton = self.paginationContainer.find('.previous-link');

        if (
            previousButton.length === 0 ||
            previousButton.is(':disabled')
        ) {
            return;
        }

        this.selectLastRowAfterPaging = true;

        previousButton.trigger('click');
    }

    private goToNextPage() {
        var self = this;
        var nextButton = self.paginationContainer.find('.next-link');

        if (
            nextButton.length === 0 ||
            nextButton.is(':disabled')
        ) {
            return;
        }

        this.selectLastRowAfterPaging = false;

        nextButton.trigger('click');
    }

    private selectFirstTableRow() {
        var self = this;
        var firstRow = self.linesTableBody
            .find('tr.article-match-line:visible')
            .first();

        if (firstRow.length === 0) {
            return;
        }

        var scrollContainer = self.linesTableBody
            .closest('.article-match-lines')[0] as HTMLElement;

        firstRow.trigger('click');

        requestAnimationFrame(() => {
            scrollContainer.scrollTo({
                top: 0,
                behavior: 'auto'
            });
        });
    }

    private selectLastTableRow() {
        var self = this;
        var lastRow = self.linesTableBody
            .find('tr.article-match-line:visible')
            .last();

        if (lastRow.length === 0) {
            return;
        }

        lastRow.trigger('click');

        lastRow[0]?.scrollIntoView({
            block: 'nearest'
        });
    }

    //#endregion

    private disposeArticleMatchPopovers(): void {
        try {
            $('.article-match-info').each(function () {
                const element = $(this);

                try {
                    element.popover('dispose');
                } catch {
                    // Popover was mogelijk nog niet geïnitialiseerd.
                }
            });

            /*
            * Eventuele achtergebleven popover-elementen opruimen.
            * Dit kan gebeuren wanneer de oorspronkelijke trigger al
            * uit de DOM is verwijderd.
            */
            $('.article-match-explanation-popover').remove();
            
            $('[data-bs-toggle="tooltip"]').tooltip('dispose');
        }
        catch (exception) {
            console.error(
                `Error in ${this.disposeArticleMatchPopovers.name}`,
                exception);
        }
    }
}